import { SpecificErrorMessage } from "@shared/primitive-components/src/Errors"
import * as t from "io-ts"

export const Doc = t.readonly(
  t.type({
    url: t.string,
    key: t.string,
  })
)

export const Docs = t.readonlyArray(Doc)

export type Document = t.TypeOf<typeof Doc>
export type Documents = t.TypeOf<typeof Docs>

export enum DocumentPortalTestIds {
  Error = `flock-document-portal-error`,
  Loader = `flock-document-portal-loading`,
  Empty = `flock-document-portal-empty`,
  Portal = `flock-document-portal`,
  ReportingIncident = `flock-document-portal-reporting-incident`,
  DriverChecklist = `flock-document-portal-driver-checklist`,
  ImportanceOfEarlyNotification = `flock-document-portal-importance-of-early-notification`,
}

export type UseDocumentsInput = {
  policyId: string
}

export type UseDocuments = {
  loading: boolean
  error?: SpecificErrorMessage
  data?: Documents
  refetch: () => Promise<void>
}
